export default __webpack_public_path__ + "static/media/cloud-upload.c4e1c1fa.svg";